import React, { useMemo } from 'react';
import { v4 } from 'uuid';
import { Field, Select } from '@panwds/react-ui';

function SelectColumns(_a) {
    var button = _a.button, columns = _a.columns, label = _a.label, onSelectColumn = _a.onSelectColumn, selectedColumnIds = _a.selectedColumnIds, showLabel = _a.showLabel;
    var labelId = useMemo(function () { return "table-select-".concat(v4(), "-label"); }, []);
    var buttonId = useMemo(function () { return "table-select-".concat(v4(), "-button"); }, []);
    var items = useMemo(function () {
        return columns.map(function (c) { return ({
            value: c.id,
            children: c.render("Header")
        }); });
    }, [columns]);
    var selectedItems = useMemo(function () {
        return items.filter(function (item) { return selectedColumnIds.some(function (s) { return s === item.value; }); });
    }, [items, selectedColumnIds]);
    return (React.createElement(Field, { label: label, labelId: labelId, showLabel: showLabel, control: React.createElement(Select, { labelId: labelId, toggleButtonId: buttonId, enableMultiSelect: true, button: button, items: items, menuStyle: { maxWidth: "20rem" }, onChange: function (_a) {
                var selectedItem = _a.selectedItem;
                onSelectColumn(selectedItem.value);
            }, selectedItem: selectedItems }) }));
}

export { SelectColumns };
//# sourceMappingURL=SelectColumns.esm.js.map
